// state
export const state = () => ({
	loading: false,
	information: {}
})

// Actions
export const actions = {

	// Get about us information
	async getAboutUs({ commit }) {
		try {
			commit('setLoading', true)
			await this.$axios.get(`/about-us`).then(response => {
				commit('setInformation', response.data.data)
				commit('setLoading', false)
			}).catch(() => {
				commit('setLoading', false)
			})
		} catch (error) {
			commit('setLoading', false)
		}

	},

}

// Mutations
export const mutations = {
	setLoading(state, val) {
		state.loading = val
	},
	setInformation: (state, val) => {
		state.information = val
	}
}


// Getters
export const getters = {
	loading: state => state.loading,
	information: state => state.information
}